export class AbTabsController {

  private currentSelectedId: string | null = null;

  private handleClick = (event: MouseEvent) => {
    this.onElementSelected(event.target as HTMLElement);
  };

  constructor(private rootEl: HTMLElement) {
    this.rootEl.classList.add("ab-tabs");
    this.bindEvents();
    const firstTabId = this.rootEl.querySelector('.ab-tabs__title-wrapper')?.getAttribute('data-tab-index');
    if(!firstTabId) return;
    this.selectTab(firstTabId);
  }

  public bindEvents() {
    this.rootEl.addEventListener('click', this.handleClick);
  }

  public destroy() {
    this.rootEl.removeEventListener('click', this.handleClick);
    this.currentSelectedId = null;
  }

  private onElementSelected(selectedElement: HTMLElement) {
    if (!selectedElement) return;

    const tabEl = selectedElement.closest('.ab-tabs__title-wrapper') as HTMLElement | null;
    if (!tabEl) return;

    const tabId = tabEl.getAttribute('data-tab-index');
    if (!tabId || tabId === this.currentSelectedId) return;

    this.selectTab(tabId);
  }

  private selectTab(tabId: string) {

    const targetContent = this.rootEl.querySelector(`.ab-tabs__content-wrapper[data-tab-index="${tabId}"]`);
    const targetTitle = this.rootEl.querySelector(`.ab-tabs__title-wrapper[data-tab-index="${tabId}"]`);

    if (!targetContent || !targetTitle) return;

    this.rootEl
      .querySelectorAll('.ab-tabs__content-wrapper')
      .forEach(el => el.classList.remove('ab-tabs__content-wrapper--selected'));

    this.rootEl
      .querySelectorAll('.ab-tabs__title-wrapper')
      .forEach(el => el.classList.remove('ab-tabs__title-wrapper--selected'));

    targetContent.classList.add('ab-tabs__content-wrapper--selected');
    targetTitle.classList.add('ab-tabs__title-wrapper--selected');

    this.reorderTitles(tabId);

    this.currentSelectedId = tabId;
  }

  private reorderTitles(selectedId: string) {
    let isAfterSelected: boolean = false;
    for ( const element of Array.from(this.rootEl.querySelectorAll('.ab-tabs__title-wrapper') ) )  {
      (element as HTMLElement).style.order = isAfterSelected ? '1' : '-1';
      if (element.classList.contains('ab-tabs__title-wrapper--selected')) {
        isAfterSelected = true;
      }
    }
  }

}